import { Chip } from "@material-ui/core";
import PersonIcon from "@material-ui/icons/Person";
import React from "react";
import { useTranslation } from "../../hooks/useTranslation";

type TagDriverProps = {
  driver?: boolean;
  small?: boolean;
};

const TagDriver = ({ driver, small }: TagDriverProps) => {
  const { t, BundleKey } = useTranslation();
  return (
    <Chip
      icon={<PersonIcon />}
      label={
        driver
          ? t(BundleKey.DIALOG_MULTIPLEEXIT_TAGDRIVER_DRIVER)
          : t(BundleKey.DIALOG_MULTIPLEEXIT_TAGDRIVER_COMPANION)
      }
      color="primary"
      size={small ? "small" : "medium"}
    />
  );
};

export default TagDriver;
